import React, { Fragment } from 'react'
import { Image, Button, Center } from '@chakra-ui/react'
import intl from '../../utils/intl';

const PreviewItem = (props) => {

  const { imageSRC, trackSRC } = props;
  
	const imageOnload = (e) => {
		const { offsetHeight, offsetWidth } = e.target;
		props.onImageLoaded({w: offsetWidth, h: offsetHeight});
	}

  return (
    <Fragment>
      <div className="col-lg-5 mt-5 mt-lg-0">
        <div className="title-heading mb-4">
          <h2 className="headingWh ">{intl.get("preview_item")}</h2>
        </div>
        <div className="aboutitem">
          <div className="aboutitemImg">
						{/* <IoMdImage size="100" /> */}
            <Image onLoad={(e) => imageOnload(e)} className="img-fluid" src={imageSRC ? imageSRC : "/assets/img/loading.jpg"} alt="img" />
          </div>
          <div className="bgdarkbluecolor">
            <Center height="80px" bg="#f0f3f4">
              {trackSRC && <audio src={trackSRC} controls/>}
            </Center>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default PreviewItem